import ims from '../imports';

export default {
  getSecretIds: function () {
    return ims.axios({
      method: 'get',
      headers: {
        Authorization: 'Bearer ' + ims.firebase_auth.getAccessToken(),
      },
      baseURL: ims.config.api.prefix,
      url: `/secret_ids`,
      responseType: 'json',
      timeout: 1000 * 5,
    });
  },
};
